export const UPDATE_REQUEST = "UPDATE_REQUEST";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS";
export const UPDATE_ERROR = "UPDATE_ERROR";
export const EMAIL_UPDATE_ERROR = "EMAIL_UPDATE_ERROR";
export const EMAIL_UPDATE_REQUEST = "EMAIL_UPDATE_REQUEST";
export const EMAIL_UPDATE_SUCCESS = "EMAIL_UPDATE_SUCCESS";
export const SPECILITY_BY_ID_REQUEST = "SPECILITY_BY_ID_REQUEST";
export const SPECILITY_BY_ID_SUCCESS = "SPECILITY_BY_ID_SUCCESS";
export const SPECILITY_BY_ID_ERROR = "SPECILITY_BY_ID_ERROR";

export const specilityByIdRequest = (payload) => ({
  type: SPECILITY_BY_ID_REQUEST,
  ...payload,
});

export const specilityByIdSuccess = (authData) => ({
  type: SPECILITY_BY_ID_SUCCESS,
  authData,
});

export const specilityByIdError = (error) => ({
  type: SPECILITY_BY_ID_ERROR,
  error,
});
export const emailUpdateRequest = (payload) => ({
  type: EMAIL_UPDATE_REQUEST,
  ...payload,
});

export const emailUpdateSuccess = (authData) => ({
  type: EMAIL_UPDATE_SUCCESS,
  authData,
});

export const emailUpdateError = (error) => ({
  type: EMAIL_UPDATE_ERROR,
  error,
});
export const updateRequest = (payload) => ({
  type: UPDATE_REQUEST,
  ...payload,
});

export const updateSuccess = (authData) => ({
  type: UPDATE_SUCCESS,
  authData,
});

export const updateError = (error) => ({
  type: UPDATE_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/userprofile/actions.js